import { render, staticRenderFns } from "./SelectClassCard.vue?vue&type=template&id=740f0ee0&scoped=true&"
import script from "./SelectClassCard.vue?vue&type=script&lang=js&"
export * from "./SelectClassCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectClassCard.vue?vue&type=style&index=0&id=740f0ee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f0ee0",
  null
  
)

export default component.exports